module.exports = __webpack_public_path__ + "media/images/pic/saska/test_lessons-276d859a08871cfb53cb8f890686aa9a.svg";